import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import LeftGrid from "./LeftGrid";

const Ecommerce = () => {
  return (
    <Fragment>
      <Breadcrumbs
        mainTitle="Tổng quan tình hình xử lý vi phạm"
        parent="Dashboard"
        title="E-Commerce"
      />
      <Container fluid={true}>
        <Row className="size-column">
          <LeftGrid />
        </Row>
      </Container>
    </Fragment>
  );
};

export default Ecommerce;
